/** Clears stale Radix modal side effects when a layer fails to unmount cleanly. */
export function releaseRadixPointerLock(): void {
  if (typeof document === "undefined") return;

  document.body.style.pointerEvents = "";
  document.body.style.overflow = "";
  document.body.removeAttribute("data-scroll-locked");
  document.documentElement.style.overflow = "";
  document.documentElement.removeAttribute("data-scroll-locked");
}
